import { Alert, Snackbar, type SnackbarCloseReason } from "@mui/material";
import { useState } from "react";

import { useNotificationStore } from "@/stores/notification.store";
import * as styles from "./GlobalNotifier.styles";

const AUTO_HIDE_MS = 6000;

/** Shows queued app notifications one at a time; mounted once at the root. */
export function GlobalNotifier() {
  const current = useNotificationStore((state) => state.queue[0]);
  const dismiss = useNotificationStore((state) => state.dismiss);
  const [closingId, setClosingId] = useState<number | null>(null);

  const handleClose = (_event?: unknown, reason?: SnackbarCloseReason) => {
    if (reason === "clickaway" || !current) return;
    setClosingId(current.id);
  };

  return (
    <Snackbar
      key={current?.id}
      open={Boolean(current) && closingId !== current?.id}
      autoHideDuration={AUTO_HIDE_MS}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={styles.snackbar}
      slotProps={{ transition: { onExited: () => current && dismiss(current.id) } }}
    >
      {current ? (
        <Alert severity={current.severity} variant="filled" onClose={handleClose} sx={styles.alert}>
          {current.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
}
